import React, { useState, useEffect } from "react";
import { getAtletaPorNumero } from "./utils";
import { use } from "react";

const Court = ({
  visitorNumbers,
  homeNumbers,
  setterPosition,
  teams,
  positionHome,
  // homeLefts,
}) => {
  // const [homeLeft, setHomeLeft] = useState(false);

  const homeLeft = positionHome;
  const generateBalls = (team, positions, numbers, levantador) => {
    const equipe = team === "home" ? teams?.home : teams?.away;

    return positions.map((pos, index) => {
      let numero = numbers?.[index] ?? "";
      const atleta = getAtletaPorNumero(numero, equipe);
      const isLevantador = index === levantador;
      const isLibero =
        atleta?.funcao?.toLowerCase() === "líbero" ||
        atleta?.funcao?.toLowerCase() === "l";

      let bgClass = team === "home" ? "bg-blue-700" : "bg-red-700";
      let textClass = team === "home" ? "text-white" : "text-white";
      let borderClass = team === "home" ? "" : "";

      if (isLibero) {
        bgClass = "bg-white";
        textClass = "text-black";
        borderClass =
          team === "home"
            ? "border-2 border-blue-700"
            : "border-2 border-red-700";
      }

      if (isLevantador) {
        borderClass =
          team === "home" ? "border-2 border-white" : "border-2 border-white";
      }

      return (
        <div
          key={`ball-${team}-${index + 1}`}
          className={`absolute rounded-full w-8 h-8 flex items-center justify-center text-l font-bold ${bgClass} ${textClass} ${borderClass}`}
          style={{
            top: pos.top,
            left: pos.left,
          }}
          title={atleta?.nomeCompleto || ""}
        >
          {numero}
        </div>
      );
    });
  };

  // const positionsH = [
  //   { top: "70%", left: "22%" }, //1
  //   { top: "70%", left: "73%" }, //2
  //   { top: "40%", left: "73%" }, //3
  //   { top: "10%", left: "73%" }, //4
  //   { top: "10%", left: "22%" }, //5
  //   { top: "40%", left: "18%" }, //6
  // ];
  const positionsH = [
    { top: "70%", left: "22%" }, //1
    { top: "70%", left: "73%" }, //2
    { top: "40%", left: "73%" }, //3
    { top: "10%", left: "73%" }, //4
    { top: "10%", left: "22%" }, //5
    { top: "40%", left: "18%" }, //6
  ];

  const positionsV = [
    { top: "10%", left: "63%" }, //1
    { top: "10%", left: "10%" }, //2
    { top: "40%", left: "10%" }, //3
    { top: "70%", left: "10%" }, //4
    { top: "70%", left: "63%" }, //5
    { top: "40%", left: "67%" }, //6
  ];

  const homeIsRight = () => {
    return (
      <>
        <div className="absolute left-1/2 w-1/2 h-full p-2">
          {generateBalls(
            "home",
            positionsV,
            homeNumbers,
            setterPosition[0] - 1
          )}
        </div>
        <div className="absolute left-0 w-1/2 h-full p-2">
          {generateBalls(
            "away",
            positionsH,
            visitorNumbers,
            setterPosition[1] - 1
          )}
        </div>
      </>
    );
  };

  const homeIsLeft = () => {
    return (
      <>
        <div className="absolute left-1/2 w-1/2 h-full p-2">
          {generateBalls(
            "away",
            positionsV,
            visitorNumbers,
            setterPosition[1] - 1
          )}
        </div>
        <div className="absolute left-0 w-1/2 h-full p-2">
          {generateBalls(
            "home",
            positionsH,
            homeNumbers,
            setterPosition[0] - 1
          )}
        </div>
      </>
    );
  };

  return (
    <div className="relative w-[300px] h-[150px] bg-orange-300 border-2 border-white mx-auto mt-5">
      {/* Linhas de quadra */}
      <div className="absolute left-1/2 w-[57px] h-full bg-orange-400"></div>
      <div className="absolute right-1/2 w-[57px] h-full bg-orange-400"></div>
      <div className="absolute left-1/2 w-[5px] h-full bg-white"></div>

      <div className="absolute left-[89px] bottom-0 w-[3px] h-full bg-white"></div>
      <div className="absolute left-[203px] w-[3px] h-full bg-white"></div>

      <div
        className="absolute left-[89px] top-[-28px] w-[0px] h-[200px] border-l-2 border-white border-dashed pointer-events-none"
        style={{ zIndex: 2 }}
      ></div>
      <div
        className="absolute left-[203px] top-[-28px] w-[0px] h-[200px] border-l-2 border-white border-dashed pointer-events-none"
        style={{ zIndex: 2 }}
      ></div>
      {homeLeft ? homeIsLeft() : homeIsRight()}
    </div>
  );
};

export default Court;
